import React from 'react';
import PropTypes from 'prop-types';

import {
  Root,
  ImageContainer,
  ImageCorner,
  Image,
  ContentContainer,
  Title,
  Desc,
  Cta,
} from './EducationTypeCard.style';

const COLOR_VARIANTS = {
  1: '#4398E7',
  2: '#533FA4',
  3: '#9457A3',
  4: '#84B07B',
  5: '#E74391',
  6: '#E1000F',
};

export const EducationTypeCard = ({
  type = 1,
  imgSrc = '',
  title = '',
  desc = '',
  ctaText = '',
  ctaUrl = '/',
  corner = true,
}) => {
  const accentColor = (type) => COLOR_VARIANTS[type];

  return (
    <Root>
      <ImageContainer to={ctaUrl}>
        <Image src={imgSrc} alt="" />
        {corner && (
          <ImageCorner
            xmlns="http://www.w3.org/2000/svg"
            width={67}
            viewBox="0 0 67 60"
          >
            <path
              d="M 0 0 L 0 59.5 L 66.5 0 L 0 0 Z"
              fill={accentColor(type)}
            ></path>
          </ImageCorner>
        )}
      </ImageContainer>
      <ContentContainer>
        <Title>{title}</Title>
        <Desc>{desc}</Desc>
        <Cta to={ctaUrl} style={{ backgroundColor: accentColor(type) }}>
          <span>{ctaText}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width={16}
            height={16}
          >
            <path
              d="m5.683 14.354-1.055-1.058 5.111-5.1v-.389l-5.111-5.1L5.684 1.65l5.55 5.541v1.626Z"
              fill="currentColor"
            />
          </svg>
        </Cta>
      </ContentContainer>
    </Root>
  );
};

EducationTypeCard.propTypes = {
  type: PropTypes.number,
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  desc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  ctaUrl: PropTypes.string.isRequired,
};
